
import { ISsrConfigService } from "./ISsrConfigService";
import { BlindConfigService } from "../Common/BlindConfigurations/BlindConfigService";
import { SsrVersionedService as SsrBaseVersionedService } from "./VersionedOptions/^0.0.0.0/SsrVersionedService"
import { ISsr_4_0_0_0 } from "./VersionedOptions/^4.0.0.0/ISsrVersionedService";
import { Ssr_4_0_0_0 } from "./VersionedOptions/^4.0.0.0/SsrVersionedService";

export class SsrConfigService extends SsrBaseVersionedService implements ISsrConfigService {
    public static readonly ServiceName: string = "SsrConfigService";

    private _services: Record<string, any> = {
        Ssr_4_0_0_0: new Ssr_4_0_0_0(),
    };

    constructor() {
        super();
    }

    GetServiceName(): string {
        return SsrConfigService.ServiceName;
    }

    VersionedConfigurationOptions(): VersionedOptions {
        return {
            ['^4.0.0.0']: this._services.Ssr_4_0_0_0,
        };
    }
}

export type VersionedOptions = {
    '^4.0.0.0': ISsr_4_0_0_0
};

